import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Container } from '../../../components';
import DevLogger from '../../../components/_dev-logger';
import apiService from '../../../features/api/service';

const SurveyTableHead = () => {
  return (
    <thead className="text-left">
      <tr>
        <th className="border px-2 py-1">id</th>
        <th className="border px-2 py-1">kategori</th>
        <th className="border px-2 py-1">nama</th>
        <th className="border px-2 py-1">pretest</th>
        <th className="border px-2 py-1">posttest</th>
        <th className="border px-2 py-1">action</th>
      </tr>
    </thead>
  )
}

const SurveyItem = ({data, handleDelete}) => {
  const d = data
  return (
    <tr>
      <td className="border px-2 py-1">{d.pkBaselineEndlineSurveyId}</td>
      <td className="border px-2 py-1">{JSON.stringify(d.variablePerubahan.kategori)}</td>
      <td className="border px-2 py-1">{JSON.stringify(d.variablePerubahan.nama)}</td>
      <td className="border px-2 py-1">{d.pretest}</td>
      <td className="border px-2 py-1">{d.posttest}</td>
      <td className="border px-2 py-1"><button className="border px-2" onClick={() => handleDelete(d.pkBaselineEndlineSurveyId)}>delete</button></td>
    </tr>
  )
}

const Impact = (props) => {
  const id = props.match.params.id
  const [formSurvey, setFormSurvey] = useState([])
  const [form, setForm] = useState({})
  const [program, setProgram] = useState({
    activityResult: {
      baselineEndlineSurvey: []
    }
  })

  useEffect(() => {
    apiService.getById('programs', id).then(res => {
      const result = res.results
      setProgram(result)
    })
  }, [id])

  const { activityResult } = program
  const { baselineEndlineSurvey } = activityResult

  const handleDelete = (id) => {
    if(id){
      apiService.delete('programs_survey', id)
      .then(() => {
        toast.success('Deleted.')
      })
      .catch(err => {
        console.log({err})
        toast.error('Error.')
      })
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    const {
      name,
      category,
      pretest,
      posttest
    } = form

    const survey = {
      variablePerubahan: {
        kategori: category,
        nama: name
      },
      pretest,
      posttest
    }

    setFormSurvey([
      ...formSurvey,
      survey
    ])

    console.log(form)
  }

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  const sendRequest = () => {
    const requestBody = {
      "beneficiariesMen": 10,
      "beneficiariesWomen": 11,
      "beneficiariesMenDifable": 20,
      "beneficiariesWomenDifable": 20,
      "retentionSaatProgramMen": 10,
      "retentionSaatProgramWomen": 9,
      "retentionPascaProgramMen": 8,
      "retentionPascaProgramWomen": 10,
      "satisfactionSangatTidakPuas": 17,
      "satisfactionTidakPuas": 15,
      "satisfactionNetral": 13,
      "satisfactionPuas": 12,
      "satisfactionSangatPuas": 10,
      "customerAcquisitionScore": 8,
      "netPromotorScoreDetractors": 7,
      "netPromotorScorePassive": 6,
      "netPromotorScorePromoters": 30,
      "baselineEndlineSurvey": formSurvey
    }

    const activityResultId = program?.activityResult?.pkActivityResultId

    if(activityResultId){
      apiService.update('programs_statistic', activityResultId, requestBody)
        .then(res => {
          console.log(res)
          toast.success('Updated.')
        })
        .catch(err => {
          console.log({err})
          toast.error('Error.')
        })
    } else {
      toast.error('Error 400: activityResultId not provided.')
    }
  }

  return (
    <Container className="py-10 lg:py-20">
      <p>Program ID: {id}</p>

      <div className="p-4 border">
        <p>Baseline-Endline Survey pada Database:</p>
        <table>
          <SurveyTableHead />
          <tbody>
            {
              baselineEndlineSurvey.map(d => (
                <SurveyItem key={d.pkBaselineEndlineId} data={d} handleDelete={handleDelete}/>
              ))
            }
          </tbody>
        </table>
      </div>

      <div className="p-4 border">
        <p>Baseline-Endline Survey yang akan disimpan:</p>
        <table>
          <SurveyTableHead />
          <tbody>
            {
              formSurvey.map((d, index) => (
                <SurveyItem key={index} data={d} handleDelete={() => {}}/>
              ))
            }
          </tbody>
        </table>
        <button className="border" onClick={sendRequest}>Simpan</button>
      </div>

      <hr className="my-4"/>

      <form className="border p-4" onSubmit={handleSubmit}>
        <DevLogger data={form}/>
        <input onChange={handleChange} name="name" placeholder="name" className="block border p-2"/>
        <input onChange={handleChange} name="category" placeholder="category" className="block border p-2"/>
        <input onChange={handleChange} name="pretest" type="number" placeholder="pretest" className="block border p-2"/>
        <input onChange={handleChange} name="posttest" type="number" placeholder="posttest" className="block border p-2"/>
        <button className="border">submit</button>
      </form>
    </Container>
  )
}

export default Impact
